<template>
  <div id="main" :class="[device, deviceHeight]">
    <router-view />
  </div>
</template>

<script>
import { isMobile } from "mobile-device-detect";
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  unmounted() {
    window.removeEventListener("resize", this.onResize);
  },
  computed: {
    device() {
      if (!isMobile && this.windowHeight < 700) {
        return "popup";
      }
      return isMobile ? "mob" : "pc";
    },
    deviceHeight() {
      if (this.windowHeight < 1000) {
        return "s";
      }
      return "l";
    },
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
  },
};
</script>

<style lang='sass'>
@import 'src/assets/styles/reset.sass'
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;700;900&family=Roboto:wght@700&display=swap')
</style>
